module.exports = __webpack_public_path__ + "static/about-3-231afd1efd5287b4eaa339f49f7b1745.jpg";